module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei6.svg";